import React from 'react';
import { Box, Alert, IconButton, Slide } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useToast } from '../../contexts/ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const getSeverity = (type) => {
    switch (type) {
      case 'success': return 'success';
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return 'info';
    }
  };

  const getColor = (type) => {
    switch (type) {
      case 'success': return '#4caf50'; // GREEN
      case 'error': return '#f44336'; // RED
      case 'warning': return '#ff9800'; // ORANGE
      case 'info': return '#2196f3'; // BLUE
      default: return '#2196f3';
    }
  };

  if (toasts.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 64, // Below AppBar (standard Material-UI Toolbar height)
        right: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxWidth: '500px',
        width: '100%',
        pointerEvents: 'none'
      }}
    >
      {toasts.map((toast) => (
        <Slide
          key={toast.id}
          direction="left"
          in={true}
          mountOnEnter
          unmountOnExit
        >
          <Box
            sx={{
              pointerEvents: 'auto',
              width: '100%'
            }}
          >
            <Alert
              severity={getSeverity(toast.type)}
              onClose={() => removeToast(toast.id)}
              sx={{
                width: '100%',
                backgroundColor: getColor(toast.type),
                color: '#fff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                '& .MuiAlert-icon': {
                  color: '#fff'
                },
                '& .MuiAlert-action': {
                  color: '#fff'
                },
                '& .MuiAlert-message': {
                  color: '#fff',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  lineHeight: 1.5,
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-wrap'
                }
              }}
              action={
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={() => removeToast(toast.id)}
                  sx={{ color: '#fff' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {toast.message}
            </Alert>
          </Box>
        </Slide>
      ))}
    </Box>
  );
};

export default ToastContainer;

